import { render, staticRenderFns } from "./animatedLogo.vue?vue&type=template&id=4ade5839&scoped=true&lang=pug"
import script from "./animatedLogo.vue?vue&type=script&lang=ts"
export * from "./animatedLogo.vue?vue&type=script&lang=ts"
import style0 from "./animatedLogo.vue?vue&type=style&index=0&id=4ade5839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade5839",
  null
  
)

export default component.exports